<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Assigned Users</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content pt-4 pb-1 px-3">

  <ng-container matColumnDef="only_archived">
    <div style="padding: 0 15px !important;">
      <mat-form-field appearance="outline" style="width:100%;" floatLabel="always" class="mb-3">
        <mat-label>Form Submission status</mat-label>
        <mat-select [(ngModel)]="filter_options.dynamic_form_status" matTooltip="Filter users by form submission status." name="dynamic_form_status">
          <mat-option value="">All Statuses</mat-option>
          <mat-option value="Assigned">Assigned</mat-option>
          <mat-option value="In Progress">In Progress</mat-option>
          <mat-option value="Submitted">Submitted</mat-option>
          <mat-option value="Pending">Pending</mat-option>
          <mat-option value="Rejected">Rejected</mat-option>
          <mat-option value="Approved">Approved</mat-option>
          <mat-option value="Approved: Work in Progress">Approved: Work in Progress</mat-option>
          <mat-option value="Work Completed">Work Completed</mat-option>
        </mat-select>
        <mat-hint>Use this to filter users by form submission status.</mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col d-flex justify-content-center">
        <button mat-raised-button color="secondary" type="button" style="width: auto;" class="mb-3" (click)="onFilterByAccount()" [matBadge]="'' + (filter_options.account_ids && filter_options.account_ids.length ? filter_options.account_ids.length : '')" matTooltip="Select from a list of accounts.">Accounts</button>
      </div>
    </div>
  </div>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
